// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__C4eL1","header":"Contacts_header__FBbuh","largeInputElement":"Contacts_largeInputElement__CK38G","title":"Contacts_title__7uOT1"};